<style lang="less" scoped>
    .search-input{
        display: inline-block;
        min-width: 250px;
        max-width: 600px;
    }
    .search-item{
        padding: 4px 8px;
        cursor: pointer;
        border: 1px solid #dddee1;
        border-radius: 6px;
        margin: 5px 0;
    }
    .search-item:hover{
        background: #f5f5f5;
    }
    .searched-customer{
        display: inline-block;
        padding: 2px 4px;
        border: 1px solid #dddee1;
        margin-right: 5px;
        margin-bottom: 5px;
        cursor: pointer;
    }
    .searched-customer:hover{
        background: #e5e5e5;
    }
    .asset-extra{
        white-space: pre-line;
        text-align: left;
    }
    .order-select{
        transform: translateY(0px);
    }
    .edit-container{
        margin: 0 auto;
        max-width: 800px;
    }
    .edit-container .ivu-btn{
        padding-left: 7px;
        padding-right: 7px;
        text-align: left;
    }
    .edit-container .ivu-form-item{
        margin-bottom: 8px;
    }
    .asset-order-config-contain {
     /deep/ .ivu-modal-body {
        max-height: 1000px!important;
      }
    }
</style>
<template>
  <div>
    <div class="line list-container">
      <div style="display:flex">
        <RadioGroup
          v-model="asset_order_params.search_type"
          type="button"
          style="margin-right:10px"
          @on-change="searchTypeChange"
        >
          <Radio label="mine">
            我发起的
          </Radio>
          <Radio label="related">
            与我相关
          </Radio>
          <!--  
            <Radio label="pending">
              待我处理
            </Radio> 
          -->
        </RadioGroup>
        <Button
          type="primary"
          icon="md-add"
          style="margin-bottom: 16px"
          @click="applyAsset"
        >
          申请固定资产
        </Button>
      </div>
      <Table
        size="small"
        :columns="asset_order_columns"
        :data="asset_orders"
        :loading="loading"
      />
    </div>

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>

    <Modal
      v-model="asset_order_config.modal"
      title="固定资产申请"
      ok-text="保存"
      class="asset-order-config-contain"
      :mask-closable="false"
      :z-index="100"
    >
      <div class="line">
        <Form
          ref="form"
          :model="edit_asset_order" 
          :label-width="120"
          :rules="rules"
        >
          <div class="line">
            <Row>
              <i-col>
                <FormItem 
                  prop="asset_order_name_id"
                  label="申请设备名称"
                >
                  <Select
                    v-model="edit_asset_order.asset_order_name_id"
                    filterable
                    placeholder="选择名称"
                  >
                    <Option
                      v-for="item in asset_order_names"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </Option>
                  </Select>
                </FormItem>
              </i-col>
              <i-col>
                <FormItem
                  prop="asset_model"
                  label="申请设备型号或配置"
                >
                  <i-input
                    v-model.trim="edit_asset_order.asset_model"
                    placeholder="请输入"
                  />
                </FormItem>
              </i-col>
            </Row>
            <Row>
              <i-col>
                <FormItem
                  prop="count"
                  label="需要数量"
                >
                  <i-input
                    v-model.trim="edit_asset_order.count"
                    placeholder="请输入"
                    type="number"
                  />
                </FormItem>
              </i-col>
              
              <i-col>
                <FormItem
                  prop="expect_lead_date"
                  label="期望领用日期"
                >
                  <DatePicker
                    size="small"
                    :value="edit_asset_order.expect_lead_date"
                    placeholder="请输入"
                    @on-change="function(date){itemDateChange(edit_asset_order, 'expect_lead_date', date)}"
                  />
                </FormItem>
              </i-col>
            </Row>
            <Row>
              <i-col>
                <FormItem 
                  prop="lead_reason"
                  label="领用原因"
                >
                  <i-input
                    v-model="edit_asset_order.lead_reason"
                    type="textarea"
                    placeholder="请输入"
                  />
                </FormItem>
              </i-col>
            </Row>
            <Row>
              <i-col>
                <FormItem label="给劳务派遣申请">
                  <Checkbox v-model="edit_asset_order.intern_show" />
                </FormItem>
              </i-col>
            </Row>
            <Row>
              <i-col>
                <FormItem 
                  v-if="edit_asset_order.intern_show"
                  label="劳务派遣"
                >
                  <CustomeSelect 
                    v-model="edit_asset_order.intern_id"
                    transfer
                    clearable
                    :formal="false"
                  />
                </FormItem>
              </i-col>
            </Row>
          </div>
        </Form>
        <Row />
      </div>
      <div slot="footer">
        <Button
          @click="closeModal"
        >
          取消
        </Button>
        <Button
          type="primary"
          :loading="asset_order_config.loading"
          @click="editOk"
        >
          确定
        </Button>
      </div>
    </Modal>

    <!-- <Backdrop v-show="getting_target_asset"></Backdrop> -->
    <!--
        <AssetPrint ref="printer"></AssetPrint>
        <AssetApplicationPrint ref="applicationPrinter"></AssetApplicationPrint>
        <CustomerAsset ref="CustomerAsset"></CustomerAsset> -->
  </div>
</template>
<script route="/asset/application">
  import Util from '../../libs/util';
  import UserFlowBase from '../components/flow/user_flow_base';
  import FlowUtil from '../../libs/flow_util'
  import AssetOrderExpand from './components/asset_order_expand'
  import CustomeSelect from '@/views/components/customer/selector'
  import { mapGetters } from "vuex";
  // import AssetPrint from './components/asset_print';
  // import AssetApplicationPrint from './components/asset_application_print';
  // import CustomerAsset from './components/customer_asset';
  // import FileUploader from '../components/file/uploader';
  const edit_asset_order_initdata = {
    intern_id:null,
    asset_order_name_id: 0,
    asset_model: '',
    count:null,
    expect_lead_date: null,
    lead_reason:null,
    operate_type:null,
    intern_show: false,
    // office_location: ''
  }
  export default {
    /* router_info_start */
    router_info: '/asset/application',
    /* router_info_end */
    // components: { AssetPrint, AssetApplicationPrint, CustomerAsset, FileUploader },
    components: {
      CustomeSelect
    },
    data() {
      return {
        asset_order_params: {
          per_page: 10,
          page: 1,
          search: '',
          search_type: 'mine'
        },
        asset_order_config: {
          modal: false,
          loading:false
        },
        asset_orders: [],
        query_asset_path: Util.api.query_asset,
        query_customer_path: Util.api.query_customer_with_team_company,
        import_path: Util.api.import_asset,
        search_customer_params: {
          search: ''
        },
        search_customer_config: {
          icon: 'ios-search',
          method: 'get',
          name: '搜索',
          processingName: '搜索中...',
          successedName: '搜索员工',
          failedName: '搜索失败',
        },
        rich_text_config: {
          show: true,
          fixed: false,
          show_handler: false,
          width: '100%',
          title: '备注:'
        },
        searched_customers: [],
        asset_brands: [],
        asset_brands_hash: {},
        asset_device_types: [],
        asset_device_types_hash: {},
        asset_types: [],
        asset_types_hash: {},
        asset_order_names: [],
        asset_order_names_hash: {},
        asset_locations: [],
        asset_locations_hash: {},
        asset_stocks: [],
        asset_no_use_stock: {},
        asset_stocks_hash: {},
        asset_order_columns: [{
                                title: '展开',
                                type: 'expand',
                                align: 'center',
                                width: 60,
                                render: (h, params) => {
                                  return h(AssetOrderExpand, {
                                    props: {
                                      asset_order_id: params.row.id
                                    }
                                  })
                                }
                              }, {
                                title: '申请设备名称',
                                align: 'center',
                                render: (h, params) => {
                                  const asset_order_name = params.row.asset_order_name
                                  return h('div', params.row.asset_name_str || asset_order_name.name)
                                }
                              }, {
                                title: '申请设备型号或配置',
                                align: 'center',
                                render: (h, params) => {
                                  return h('div', params.row.asset_version ? params.row.asset_version.name : params.row.asset_model)
                                }
                              }, {
                                title: '需要数量',
                                align: 'center',
                                render: (h, params) => {
                                  return h('div', params.row.count)
                                }
                              }, {
                                title: '领用原因',
                                align: 'center',
                                render: (h, params) => {
                                  return h('div', params.row.lead_reason)
                                }
                              }, 
                              // {
                              //   title: '办公地点',
                              //   align: 'center',
                              //   key: 'office_location'
                              // },
                              {
                                title: '劳务派遣',
                                align: 'center',
                                width: 125,
                                render: (h, {row = {}} = {}) => {
                                  return <span>{(row.intern && row.intern.account) || '-'}</span>
                                }
                              },
                              // { 
                              //   title: '购入价格',
                              //   align: 'center',
                              //   minWidth:100,
                              //   render: (h, {row = {}} = {}) => {
                              //     const asset_price = [null, undefined, ''].includes(row.asset_price) ? '-' : row.asset_price
                              //     if (asset_price !== '-') {
                              //       return <div>{this.formattingNumber(asset_price, 2) }</div>
                              //     }
                              //     return <div>-</div>
                              //   }
                              // },
                              // { // todo
                              //   title: '预计到货日期',
                              //   align: 'center',
                              //   minWidth:120,
                              //   render: (h, {row = {}} = {}) => {
                              //     return <div>{row.expect_arrival_date || '-'}</div>
                              //   }
                              // }, 
                              {
                                title: '期望领用时间',
                                align: 'center',
                                render: (h, params) => {
                                  return h('div', params.row.expect_lead_date)
                                }
                              }, 
                              {
                                title: '申请人',
                                align: 'center',
                                render: (h, params) => {
                                  const customer = params.row.customer || {}
                                  return h('div', customer.account)
                                }
                              },
                              {
                                title: '状态',
                                align: 'center',
                                width: 125,
                                render: (h, params) => {
                                  const row = params.row
                                  const user_flow = row.user_flow
                                  if (user_flow) {
                                    return h(UserFlowBase, {
                                      props: {
                                        user_flow: user_flow,
                                        model: row,
                                        title: row.name
                                      },
                                      on: {
                                        update: (user_flow) => {
                                          row.user_flow = user_flow;
                                        }
                                      }
                                    })
                                  } else {
                                    return h('div', '-')
                                  }
                                }
                              }, {
                                title: '操作',
                                align: 'center',
                                width: 85,
                                render: (h, params) => {
                                  const row = params.row
                                  const items = []
                                  if (FlowUtil.canEdit(row, this.cur_customer)) {
                                    items.push(h('DropdownItem', {
                                      props: {name: 'edit'}
                                    }, '编辑'))
                                  }
                                  if (FlowUtil.canEdit(row, this.cur_customer)) {
                                    items.push(h('DropdownItem', {
                                      props: {name: 'delete', divided: true}
                                    }, '废弃'));
                                  }
                                  if (!items.length) {
                                    return h('div', '-')
                                  }
                                  return h('Dropdown', {
                                    props: {
                                      trigger: 'click',
                                      placement: 'left'
                                    },
                                    on: {
                                      'on-click': (event_name) => {
                                        this.handleEvent(event_name, row, params.index)
                                      }
                                    }
                                  }, [
                                    h('Button', [
                                      h('span', '操作')
                                    ]),
                                    h('DropdownMenu', {
                                      slot: 'list'
                                    }, items)
                                  ])
                                }
                              }],
        params: {
          per_page: 15,
          page: 1,
          order: 'sort_id',
          team_id: 0,
          asset_device_type_id: 0,
          asset_type_id: 0,
          asset_brand_id: 0,
          location: '',
          search: '',
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 15
        },
        // edit_asset_order_initdata
        edit_asset_order: Util.clone(edit_asset_order_initdata),
        set_user_asset: {},
        selected_stock_id: '',
        selected_stock: {},
        selected_customer: {},
        set_customer_desc: '',
        set_customer_date: '',
        edit_config: {
          modal: false,
          loading: true
        },
        set_user_config: {
          modal: false,
          loading: true
        },
        save_user_config: {
          modal: false,
          loading: true
        },
        import_config: {
          modal: false,
          loading: true
        },
        uploading: false,
        loading: false,
        getting_target_asset: false,
        update_asset_team_id: 0,
        is_update_team: false,
        update_team_loading: false,
        // search_asset_type_text: '',
        // search_asset_type_loading: false,
        // search_asset_type_results: [],
        // asset_type_hash: {},
        // search_asset_device_type_text: '',
        // search_asset_device_type_loading: false,
        // search_asset_device_type_results: [],
        // asset_device_type_hash: {},
        // search_asset_brand_text: '',
        // search_asset_brand_loading: false,
        // search_asset_brand_results: [],
        // asset_brand_hash: {},
        // search_purchase_channel_text: '',
        // search_purchase_channel_loading: false,
        // search_purchase_channel_results: [],
        // search_asset_order_name_text: '',
        // search_asset_order_name_loading: false,
        // search_asset_order_name_results: [],
        // asset_order_name_hash: {},
        // purchase_channel_hash: {},
        print_list: [],
        asset_customer_deleting: false
      }
    },
    computed: {
      rules() {
        return {
          asset_order_name_id:[
            {
              required: true, 
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error('请选择设备名称'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          asset_model: [
            {
              required: true, 
              validator: (rule, value, callback) => {
                if ([undefined, null].includes(value) || (typeof value === 'string' && !value.trim())) {
                  callback(new Error('请填写设备型号或配置'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          count: [
            {
              required: true, 
              validator: (rule, value, callback) => {
                if ([undefined, null, ''].includes(value)) {
                  callback(new Error('请填写需要设备的数量'));
                } else if (!/^[1-9]\d*$/.test(value)) {
                  callback(new Error('请填写正整数'));
                } else {  
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          expect_lead_date: [
            {
              required: true, 
              validator: (rule, value, callback) => {
                if ([undefined, null, ''].includes(value)) {
                  callback(new Error('请选择期望领用日期'));
                } else {  
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          lead_reason: [
            {
              required: true, 
              validator: (rule, value, callback) => {
                const is_valid = [undefined, null].includes(value) || // 
                  (typeof value === 'string' && !value.trim()) // 
                if (is_valid) {
                  callback(new Error('请填写领用原因'));
                } else {  
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          // office_location: [
          //   {
          //     required: true, 
          //     message: '办公地点必选', 
          //     trigger: 'blur'
          //   }
          // ]
        }
      },
      cur_customer() {
        return this.$store.state.cur_customer
      },
      print_list_owner_account() {
        if (this.print_list.length) {
          return this.print_list[0].customer.account;
        } else {
          return '';
        }
      },
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
        jobs: 'async/jobs',
        jobs_hash: 'async/jobs_hash',
      }),
      set_user_asset_team() {
        const team_id = this.set_user_asset.team_id;
        const team = this.teams_hash[team_id];
        return team ? team.name : '无';
      },
      // office_locations() {
      //   return [
      //     {
      //       label: '成都-软件园C区',
      //     },
      //     {
      //       label: '成都-软件园E区',
      //     },
      //     {
      //       label: '成都-银泰工区',
      //     },
      //     {
      //       label: '北京-锦湖工区',
      //     },
      //   ]
      // }
    },
    created() {
      //
    },
    mounted() {
      // this.doSearch();
      this.initAssetBaseData()
      this.queryAssetOrders()
      // this.initAssetTopItem();
    },
    methods: {
      formattingNumber: Util.formattingNumber,
      searchTypeChange() {
        this.queryAssetOrders()
      },
      closeModal() {
        this.asset_order_config.modal = false
        this.$refs.form.resetFields()
      },
      applyAsset() {
        this.asset_order_config.modal = true
        this.edit_asset_order = Util.clone(edit_asset_order_initdata)
      },
      handleEvent(event_name, asset_order, index) {
        switch (event_name) {
        case 'edit':
          this.editAssetOrder(asset_order);
          break;
        case 'delete':
          this.deleteAssetOrder(asset_order, index);
          break;
        default:
          this.$Message.error('未定义操作!');
          break;
        }
      },
      queryAssetOrders() {
        this.loading = true
        Util.ajax.get(Util.api.query_mine_asset_order, {
          params: this.asset_order_params
        }).then(response => {
          return response.data
        }).then(res => {
          if (res.code === 1) {
            this.asset_orders = res.data.asset_orders
            this.page_info.current = res.data.cur_page
            this.page_info.page_size = res.data.per_page
            this.page_info.total = res.data.total_count
          }
          this.loading = false
        })
      },
      itemDateChange(item, key, date) {
        item[key] = date;
      },
      getReceiver(asset, index) {
        if (index === 2) {
          this.asset_stock_configs[index].receiver = asset.asset_stock ? {name: '转移仓库', type: 'stock'} : {name: '转移人员', type: 'customer'}
          return this.asset_stock_configs[index].receiver
        } else {
          return this.asset_stock_configs[index].receiver
        }
      },
      initAssetTopItem() {
        this.queryItem('asset_order_name');
        this.queryItem('asset_type');
        this.queryItem('asset_device_type');
        this.queryItem('asset_brand');
        this.queryItem('asset_stock');
      },
      initAssetBaseData() {
        Util.ajax.get(Util.api.asset_base_data, {
          params: {}
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.asset_brands = data.asset_brands;
            this.asset_brands.forEach((item) => {
              this.asset_brands_hash[item.id] = item;
            });
            this.asset_device_types = data.asset_device_types;
            this.asset_device_types.forEach((item) => {
              this.asset_device_types_hash[item.id] = item;
            });
            // this.asset_types = data.asset_types;
            // this.asset_types.forEach((item) => {
            //   this.asset_types_hash[item.id] = item;
            // });
            this.asset_order_names = data.asset_order_names;
            this.asset_order_names.forEach((item) => {
              this.asset_order_names_hash[item.id] = item;
            });
            this.asset_locations = data.asset_locations;
            this.asset_locations.forEach((item) => {
              this.asset_locations_hash[item.id] = item;
            });
            this.asset_stocks = data.asset_stocks.filter(asset_stock => asset_stock.asset_stock_type !== 0);
            this.asset_no_use_stock = data.asset_stocks.filter(asset_stock => asset_stock.asset_stock_type === 0)[0]
            this.asset_stocks.forEach((item) => {
              this.asset_stocks_hash[item.id] = item;
            });
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({
            title: '错误',
            content: e.message
          });
        });
      },
      editAssetOrder(asset_order) {
        if (asset_order.id) {
          this.edit_asset_order = Util.clone(asset_order);
          this.$set(this.edit_asset_order, 'intern_show', !!asset_order.intern_id)
        } else {
          this.edit_asset_order = asset_order;
        }
        this.asset_order_config.modal = true;
      },
      checkValid() {
        let msg = '';
        if (!this.edit_asset_order.asset_order_name_id) {
          msg += `<p>[名称]不能为空</p>`;
        }
        if (!this.edit_asset_order.asset_model) {
          msg += `<p>[设备型号]不能为空</p>`;
        }
        /* if(!this.edit_asset.asset_device_type_id){
                    msg += `<p>请选择[设备类型]</p>`;
                } */
        if (!(this.edit_asset_order.count > 0)) {
          msg += `<p>[需要数量]须大于0</p>`;
        }
        if (!this.edit_asset_order.lead_reason) {
          msg += `<p>[领用原因]必须填写</p>`;
        }
        if (!this.edit_asset_order.expect_lead_date) {
          msg += `<p>请设置[期望领用日期]</p>`;
        }
        if (msg) {
          this.$Modal.error({title: '提示', content: msg});
          this.edit_config.loading = false;
          setTimeout(() => {
            this.edit_config.loading = true;
          }, 500);
          return false;
        }
        return true;
      },
      editOk() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const { intern_show, ...params } = Object.assign({}, this.edit_asset_order, {
              operate_type: 0
            })
            if (!intern_show) {
              params.intern_id = ''
            }
            this.asset_order_config.loading = true
            // asset_order.intern_id = !!asset_order.intern_id
            if (params.id) {
              Util.ajax.post(Util.api.update_asset_order, params)
                .then(response => {
                  return response.data
                }).then(res => {
                  if (res.code === 1) {
                    this.asset_order_config.modal = false
                    this.$Message.success({
                      content: '操作成功!'
                    });
                    setTimeout(() => {
                      this.params.page = 1;
                      this.queryAssetOrders()
                    }, 500)
                    /*      Util.insertOrUpdateArrayItem(this.asset_orders, res.data.asset_order, true)
                    this.asset_orders = this.asset_orders.slice(0, this.page_info.page_size)
                    this.page_info.total += 1
                    this.$Message.success({
                      content: '操作成功!'
                    }); */
                  } else {
                    this.$vModal.error({
                      title:'错误',
                      content: res.msg
                    })
                  }
                }).finally(() => {
                  this.asset_order_config.loading = false
                })
            } else {
              Util.ajax.post(Util.api.add_asset_order, params)
                .then(response => {
                  return response.data
                }).then(res => {
                  if (res.code === 1) {
                    this.asset_order_config.modal = false
                    /*  Util.insertOrUpdateArrayItem(this.asset_orders, res.data.asset_order, true)
                    this.asset_orders = this.asset_orders.slice(0, this.page_info.page_size)
                    this.page_info.total += 1 */
                    this.$Message.success({
                      content: '操作成功!'
                    });
                    setTimeout(() => {
                      this.params.page = 1;
                      this.queryAssetOrders()
                    }, 500)
                  } else {
                    this.$vModal.error({
                      title:'错误',
                      content: res.msg
                    })
                  }
                }).finally(() => {
                  this.asset_order_config.loading = false
                })
            }
          }
        })
        // if(this.checkValid()){
        //     if (this.edit_asset.purchase_date instanceof Date){
        //         this.edit_asset.purchase_date = moment(this.edit_asset.purchase_date).format('YYYY-MM-DD');
        //     }
        //     Util.ajax.post(Util.api.update_asset, this.edit_asset).then((response)=>{
        //         console.log(response);
        //         return response.data;
        //     }).then((data)=>{
        //         console.log(data);
        //         if(data.code === 1){
        //             this.edit_config.modal = false;
        //             Util.insertOrUpdateArrayItem(this.assets, data.asset, true);
        //             this.$Message.success({
        //                 content: '保存成功!'
        //             });
        //         }else{
        //             this.edit_config.loading = false;
        //             setTimeout(()=>{
        //                 this.edit_config.loading = true;
        //             }, 500);
        //             this.$Modal.error({
        //                 title: '提示',
        //                 content: data.msg
        //             })
        //         }
        //     }).catch((e)=>{
        //         this.edit_config.loading = false;
        //         setTimeout(()=>{
        //             this.edit_config.loading = true;
        //         }, 500);
        //         console.log(e);
        //         this.$Message.error({
        //             content: '操作失败!'
        //         });
        //     });
        // }
      },
      doSearch() {
        this.$refs.searchBtn.doAjax();
      },
      // doSearchCustomer(query){
      //     if (this.$refs.searchCustomerBtn.length > 0) {
      //         if (query && typeof query === 'string') {
      //             this.searching_customer = true
      //             this.search_customer_params.search = query
      //         }
      //         this.$refs.searchCustomerBtn[0].doAjax();
      //     } else {
      //         if (query && typeof query === 'string') {
      //             this.searching_customer = true
      //             this.search_customer_params.search = query
      //         }
      //         this.$refs.searchCustomerBtn.doAjax();
      //     }
      // },
      pageChange(new_page) {
        this.asset_order_params.page = new_page;
        // this.loading = true;
        this.queryAssetOrders()
        // this.$refs.searchBtn.doAjax(true);
      },
      beforeSearch() {
        this.params.page = 1;
        this.loading = true;
        this.empty_tip = '获取数据中...';
        this.customers = [];
      },
      handleData(data) {
        this.loading = false;
        this.assets = [];
        data.assets.forEach((asset) => {
          this.assets.push(asset);
        });
        if (data.assets.length === 0) {
          this.empty_tip = '没有结果, 请重试!';
        }
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleFail(e) {
        this.loading = false;
        this.empty_tip = '获取数据失败, 请重试';
        console.log(e);
      },
      queryItem(type) {
        const loading_key = `search_${type}_loading`;
        if (!this[loading_key]) {
          this[loading_key] = true;
          Util.ajax.get(Util.api[`query_${type}`], {
            params: {
              search: this[`search_${type}_text`],
              page: 1,
              per_page: 10,
              order: 'use_count'
            }
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this[loading_key] = false;
            if (res.code === 1) {
              const data = res.data;
              this[`search_${type}_results`] = [];
              data.items.forEach((item) => {
                this[`search_${type}_results`].push(item);
                this[`${type}_hash`][item.id] = item;
              });
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this[loading_key] = false;
            console.log(e);
            this.$Modal.error({
              title: '错误',
              content: e.message
            });
          });
        }
      },
      setItem(type, item) {
        this[`${type}_hash`][item.id] = item;
        this.edit_asset[`${type}_id`] = item.id;
        document.body.click();
      },
      setLocation(location) {
        this.edit_asset.location = location;
        document.body.click();
      },
      purchaseDateChange(date) {
        this.edit_asset.purchase_date = date;
      },
      arriveDateChange(date) {
        this.edit_asset.arrive_date = date;
      },
      handleAssetEvent(event_name, asset, index) {
        switch (event_name) {
        case 'edit':
          this.editAsset(asset);
          break;
        case 'print':
          this.printAsset(asset);
          break;
        case 'print_application':
          this.printApplication(asset);
          break;
        case 'in_stock':
          this.assetStockConfig(asset, 0);
          break;
        case 'provide':
          this.assetStockConfig(asset, 1);
          break;
        case 'transfer':
          this.assetStockConfig(asset, 2);
          break;
        case 'return':
          this.assetStockConfig(asset, 3);
          break;
        case 'discard':
          this.disCardAsset(asset, 4);
          break;
        case 'copy':
          this.copyAsset(asset);
          break;
        case 'delete':
          this.abandonAsset(asset);
          break;
        case 'edit_desc':
          this.editDesc(asset);
          break;
        default:
          this.$Message.error('未定义操作!');
          break;
        }
      },
      printAsset(asset) {
        //window.open('/web/asset/print/'+asset.id, '_blank');
        this.$refs.printer.print(asset);
      },
      printApplication(asset) {
        this.$refs.applicationPrinter.print([asset]);
      },
      printApplications() {
        if (this.print_list.length) {
          this.$refs.applicationPrinter.print(this.print_list);
        } else {
          this.$Message.warning('请添加资产到领用表!');
        }
      },
      addToPrintList(asset) {
        if (!asset.customer_id) {
          this.$Modal.warning({
            title: '提示',
            content: '请指定资产使用人后再添加打印!'
          });
          return;
        }
        if (this.print_list.length) {
          const first_asset = this.print_list[0];
          if (asset.customer.id !== first_asset.customer.id) {
            this.$Modal.warning({
              title: '提示',
              content: '领用表中的使用人必须为同一人!'
            });
            return;
          }
        }
        if (this.isInPrintList(asset)) {
          this.$Modal.warning({
            title: '提示',
            content: '已添加进领用表, 无需重复添加!'
          });
          return;
        }
        this.print_list.push(asset);
      },
      clearPrintList() {
        this.print_list = [];
      },
      isInPrintList(asset) {
        return Util.isArrayItem(this.print_list, asset);
      },
      moveUpAssetInPrintList(index) {
        Util.moveUpArrayItemByIndex(this.print_list, index);
      },
      moveDownAssetInPrintList(index) {
        Util.moveDownArrayItemByIndex(this.print_list, index);
      },
      removeAssetInPrintList(index) {
        Util.removeArrayItemByIndex(this.print_list, index);
      },
      // provide(asset){

      // },
      // transfer(asset) {

      // },
      // discard(asset) {

      // },
      // inStock() {},
      assetStockConfig(asset, type) {
        if (!this.getting_target_asset) {
          this.getting_target_asset = true;
          Util.ajax.get(Util.api.query_asset_by_id, {
            params: {
              id: asset.id
            }
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this.getting_target_asset = false;
            if (res.code === 1) {
              this.set_user_asset = res.data;
              this.asset_stock_configs[type].modal = true;
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.getting_target_asset = false;
            this.$Modal.error({
              title: '错误',
              content: e.message
            });
            console.log(e);
          });
        }
      },
      copyAsset(asset) {
        const new_asset = Util.clone(asset);
        delete new_asset.id;
        delete new_asset.uid;
        new_asset.sn = '';
        new_asset.pn = '';
        new_asset.imei = '';
        this.editAsset(new_asset);
      },
      abandonAsset() {
        this.$Message.warning('暂未开放删除功能!');
      },
      editDesc() {
        //
      },
      // checkSetUserValid(){
      //     if(!this.set_customer_date){
      //         this.$Modal.error({
      //             title: '提示',
      //             content: '请选择领用日期'
      //         });
      //         this.save_user_config.loading = false;
      //         setTimeout(()=>{
      //             this.save_user_config.loading = true;
      //         }, 500);
      //         return false;
      //     }
      //     return true;
      // },
      setUserOK(type) {
        if (!this.set_customer_date) {
          this.$Message.error('请设置领用日期!');
          this.asset_stock_configs[type].sub_loading = false;
          setTimeout(() => {
            this.asset_stock_configs[type].sub_loading = true;
          }, 500);
          return;
        }
        const params = {}
        const userAssetCustomerId = this.set_user_asset.customer_id
        if (type === 0) {
          params.asset_stock_id = this.selected_stock.id
        } else if (type === 1) {
          params.customer_id = this.selected_customer.id
          params.from_stock_id = this.set_user_asset.asset_stock_id
        } else if (type === 2) {
          // const editAssetStockId = this.edit_asset.asset_stock_id
          if (userAssetCustomerId) {
            params.customer_id = this.selected_customer.id
            params.from_customer_id = this.set_user_asset.customer_id
          } else {
            params.asset_stock_id = this.selected_stock.id
            params.from_stock_id = this.set_user_asset.asset_stock_id
          }
        } else if (type === 3) {
          params.asset_stock_id = this.selected_stock.id
          params.from_customer_id = this.set_user_asset.customer_id
        } else if (type === 4) {
          if (userAssetCustomerId) {
            params.from_customer_id = this.set_user_asset.customer_id
          } else {
            params.from_stock_id = this.set_user_asset.asset_stock_id
          }
          params.asset_stock_id = this.asset_no_use_stock.id
        }
        if (this.set_customer_desc) {
          params.desc = this.set_customer_desc
        }
        params.asset_id = this.set_user_asset.id
        params.execute_date = moment(this.set_customer_date).format('YYYY-MM-DD')
        params.type = type
        Util.ajax.post(Util.api.add_asset_in_out_record, params).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.asset_stock_configs[type].sub_modal = false;
            this.set_user_asset = data.full_info;
            Util.insertOrUpdateArrayItem(this.assets, data.list_info);
          } else {
            this.asset_stock_configs[type].sub_loading = false;
            setTimeout(() => {
              this.asset_stock_configs[type].sub_loading = true;
            }, 500);
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.$Message.error('添加使用人失败, 请重试!');
          this.asset_stock_configs[type].sub_loading = false;
          setTimeout(() => {
            this.asset_stock_configs[type].sub_loading = true;
          }, 500);
          console.log(e);
        });
      },
      addCustomerToAsset(customer, index) {
        this.selected_customer = customer;
        this.asset_stock_configs[index].sub_modal = true;
      },
      addStockToAsset(stock_id, index) {
        this.selected_stock = this.asset_stocks.find(stock => stock.id === stock_id);
        this.asset_stock_configs[index].sub_modal = true;
      },
      disCardAsset(asset, index) {
        this.set_user_asset = asset;
        this.asset_stock_configs[index].sub_modal = true;
      },
      deleteAssetOrder(asset_order, index) {
        if (!this.asset_order_deleting) {
          this.asset_order_deleting = true
          Util.ajax.post(Util.api.delete_asset_order, {
            id: asset_order.id
          }).then((response) => {
            return response.data
          }).then((res) => {
            this.asset_customer_deleting = false
            if (res.code === 1) {
              this.asset_orders.splice(index, 1)
              this.page_info.total -= 1
              this.$Message.success({
                content: '操作成功!'
              });
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              })
            }
          }).catch(e => {
            this.asset_order_deleting = false;
            this.$Message.error('删除失败, 请重试!');
          })
        }
      },
      deleteAssetCustomer(asset_customer, index) {
        if (!this.asset_customer_deleting) {
          this.asset_customer_deleting = true;
          Util.ajax.post(Util.api.delete_asset_customer, {
            id: asset_customer.id
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this.asset_customer_deleting = false;
            if (res.code === 1) {
              this.set_user_asset.asset_customers.splice(index, 1);
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.asset_customer_deleting = false;
            this.$Message.error('删除失败, 请重试!');
            console.log(e);
          });
        }
      },
      handleSearchCustomerData(data) {
        if (data.length > 0) {
          this.searched_customers = [];
          data.forEach((customer) => {
            this.searched_customers.push(customer);
          });
        } else {
          this.$Message.error('没有搜索到相关信息');
        }
      },
      handleSearchCustomerFail(e) {
        console.log(e);
        this.$Message.error('搜索失败, 请重试!');
      },
      getItemNameById(type, id) {
        const item = this[`${type}_hash`][id];
        return item ? item.name : '-';
      },
      formatPrice(price) {
        price = price ? price : 0;
        return math.eval(price).toFixed(2);
      },
      showCustomerAssets(customer) {
        this.$refs.CustomerAsset.show(customer);
      },
      updateSetUserAssetTeam(asset, value) {
        this.update_asset_team_id = asset.team_id;
        this.is_update_team = value;
      },
      updateAssetTeam(asset) {
        if (this.update_team_loading) return;
        this.update_team_loading = true;
        Util.ajax.post(Util.api.update_asset_team, {
          id: asset.id,
          team_id: this.update_asset_team_id
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.is_update_team = false;
            asset.team_id = this.update_asset_team_id;
            this.$Message.success('修改团队成功!');
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.update_team_loading = false;
        });
      },
      importAssets() {
        this.import_config.modal = true;
      },
      importFinish() {
        this.$Modal.success({title: '提示', content: '上传成功!'});
      },
      exportAssets() {
        window.open(Util.api.export_assets + '.xlsx?' + Util.urlEncode(this.params), '_blank');
      }
    }
  }
</script>
